import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);


//获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

// 主页
const homepageIndex = resolve => require(['@/views/homepage/index.vue'], resolve);
const overview = resolve => require(['@/views/homepage/overview2.vue'], resolve);
const bigScreen = resolve => require(['@/views/homepage/bigScreen.vue'], resolve);
const bigScreen2 = resolve => require(['@/views/homepage/bigScreen2.vue'], resolve);
const bigScreen3 = resolve => require(['@/views/homepage/bigScreen3.vue'], resolve);

const baseRoute = '' + process.env.index_router_base;

// 用户/费用中心
const userIndex = resolve => require(['@/views/userCenter/index'], resolve);
const userInfo = resolve => require(['@/views/userCenter/user/Info'], resolve);
// const userIdentify = resolve => require(['@/views/userCenter/user/identify/index'], resolve);
// const userSetting = resolve => require(['@/views/userCenter/user/Setting'], resolve);
// const accountDetail = resolve => require(['@/views/userCenter/account/Detail'], resolve);
// const accountIncome = resolve => require(['@/views/userCenter/account/Income'], resolve);
// const accountSurvey = resolve => require(['@/views/userCenter/account/Survey'], resolve);
// const accountPackage = resolve => require(['@/views/userCenter/account/package'], resolve);
// const usageStatics = resolve => require(['@/views/userCenter/account/usagestatics'], resolve);
// const auditConfig = resolve => require(['@/views/userCenter/audit/config'], resolve);
// const bindManage = resolve => require(['@/views/userCenter/bind/manage'], resolve);
// 子租户管理
const tenantManage = resolve => require(['@/views/userCenter/user/tenantManage/index'], resolve);
const tenantEdit = resolve => require(['@/views/userCenter/user/tenantManage/edit'], resolve);
// 角色管理
const roleManage = resolve => require(['@/views/userCenter/user/roleManage/index'], resolve);
// 用户管理
const userManage = resolve => require(['@/views/userCenter/user/userManage/index'], resolve);


export default new Router({
  mode: 'history',
  base: baseRoute,
  routes: [{
      path: '/', // 默认跳转主页
      redirect: '/homepage'
    },{
      path: '/zygkbigscreen', // 大屏
      component: bigScreen3,
    },{
      path: '/user',
      name: 'user',
      redirect: '/user/info',
      component: userIndex,
      children: [{
        path: '/user/info',
        name: 'user-info',
        component: userInfo,
      // },{
      //   path: '/user/identify',
      //   name: 'user-identify',
      //   component: userIdentify,
      }, {
      //   path: '/user/setting',
      //   name: 'user-setting',
      //   component: userSetting,
      // },{
      //   path: '/account/detail',
      //   name: 'account-detail',
      //   component: accountDetail,
      // },{
      //   name: 'account-income',
      //   path: '/account/income',
      //   component: accountIncome
      // },{
      //   name: 'account-survey',
      //   path: '/account/survey',
      //   component: accountSurvey
      // },{
      //   name: 'account-package',
      //   path: '/account/package',
      //   component: accountPackage
      // },{
      //   name: 'account-usagestatics',
      //   path: '/account/usagestatics',
      //   component: usageStatics
      // },{
      //   name: 'audit-config',
      //   path: '/audit/config',
      //   component: auditConfig
      // },{
      //   name: 'bind-manage',
      //   path: '/bind/manage',
        // component: bindManage
      // },{
        name: 'user-tenant',
        path: '/user/tenant',
        component: tenantManage
      },{
        name: 'user-tenant-edit',
        path: '/user/tenant/edit',
        component: tenantEdit
      },{
        name: 'user-role',
        path: '/user/role',
        component: roleManage
      },{
        path: '/user/manage',
        name: 'user-manage',
        component: userManage,
      }]
    },{
      path: '/homepage', // 跳转主页
      component: homepageIndex,
      children: [{
          path: '/homepage', // 默认跳转概况查询页面
          redirect: '/homepage/overview'
        },
        {
          path: '/homepage/overview', // 跳转概况查询页面
          component: overview
        },
        {
          path: '/homepage/bigScreen/:themeType', // 跳转概况查询大屏页面
          component: bigScreen
        },
        {
          path: '/homepage/bigScreen2', // 跳转概况查询大屏页面
          component: bigScreen2
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js